<template>
  <div class="container article">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>学长</el-breadcrumb-item>
        <el-breadcrumb-item>学长评论</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">学长评论</h2>
        </div>
      </div>
    </div>

    <div class="results card">
      <div class="table-header">
        <h3 class="title">评论列表</h3>
      </div>

      <div class="values">
        <el-table :data="results"
                  border
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="50"
                           align="center"> </el-table-column>
          <el-table-column prop="id"
                           width="80"
                           label="ID"
                           align="center">
          </el-table-column>
          <el-table-column prop="article_id"
                           width="150"
                           label="文章ID"
                           align="center">
          </el-table-column>
          <el-table-column label="发布人"
                           width="300"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.create_user_obj.nickname }}/{{scope.row.create_user_obj.mobile}}</span></template>
          </el-table-column>
          <el-table-column label="评论内容"
                           width="400"
                           align="left"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.content }}</span></template>
          </el-table-column>
          <el-table-column label="评论对象"
                           width="300"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.replyed_user_obj">{{ scope.row.replyed_user_obj.nickname }}/{{scope.row.replyed_user_obj.mobile}}</span>
              <span v-else>经验</span>
            </template>
          </el-table-column>
          <el-table-column label="点赞数"
                           width="150"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.like_count }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           align="center"
                           width="300"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.create_time
                  ? $moment(scope.row.create_time).format("YYYY-MM-DD")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           width="100"
                           fixed="right">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handleDelete(scope.row)"><span class="cao">删除</span></el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-button size="mini"
                   type="danger"
                   @click="handleDelete()">批量删除</el-button>
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { commentList, deleteComment} from '@/api/senior'
export default {
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      chooseList: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleSelectionChange(val) {
      this.chooseList = val
    },
    getList() {
      commentList(this.query).then((res) => {
        this.pageTotal = res.count
        this.results = res.list
      })
    },
    // 删除
    toDetele(ids) {
      deleteComment({
        ids: ids,
      }).then((res) => {
        this.$message.success('删除成功')
        this.getList()
      })
    },
    handleDelete(row) {
      if (this.chooseList.length == 0 && row == undefined) {
        this.$message.error('还没有选择要删除的数据')
      } else {
        this.$confirm('确定要删除这些评论吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          let ids = []
          if (row) {
            ids.push(row.id)
          } else {
            this.chooseList.map((item) => {
              ids.push(item.id)
            })
          }

          this.toDetele(ids)
        })
      }
    },
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      this.getList()
    },
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.getList()
    },
  },
}
</script>

<style scoped lang="less">
.article {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 101%;
    height: 40px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;
    padding-right: 32px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .material-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
    .el-link {
      margin: 0 8px;
    }
    .item-table-column {
      text-align: left;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
}
.tag-wrap {
  text-align: left;
  width: 100%;
  min-height: 30px;
}
.el-tag {
  margin: 0px 5px;
}
</style>
